import React from "react";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../../components/noData/noData";

const LeadActivityTable = () => {
  const tableLoading = useSelector((state) => state.leadActivity.tableLoading);
  const {
    data = [],
    colHeaders = [],
    colHeaderTooltips = [],
    columns = [],
    rawDataLink
  } = useSelector((state) => state.leadActivity.tableData.tableInfo || {});
  const tooltipId = "lead-activity-table-header-tooltip";

  const columnHeaderSlot = colHeaderTooltips.reduce((acc, column) => {
    acc[column.columnHeader] = (
      <div className="d-inline" data-tooltip-id={tooltipId} data-tooltip-content={column?.tooltip}>
        {column?.label}
      </div>
    );
    return acc;
  }, {});

  return tableLoading ? (
    <LoadingAnimation />
  ) : (
    <div>
      {data?.length ? (
        <>
          <TableWithCustomSearch
            data={data}
            colHeaders={colHeaders}
            columns={columns}
            rawDataLink={rawDataLink}
            fileName="lead-activity"
            itemsPerPage={10}
            columnHeaderSlot={columnHeaderSlot}
            hideFirstCol
          />
          <Tooltip id={tooltipId} float />
        </>
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default LeadActivityTable;
